import declare from 'dojo/_base/declare';
import connect from 'dojo/_base/connect';
import lang from 'dojo/_base/lang';
import arr from 'dojo/_base/array';
import color from 'dojo/_base/Color';
import keys from 'dojo/keys';
import _WidgetBase from 'dijit/_WidgetBase';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import _WidgetsInTemplateMixin from 'dijit/_WidgetsInTemplateMixin';
import template from './QAForm.html?raw';
import registry from 'dijit/registry';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import mouse from 'dojo/mouse';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
export default declare("WidgetCollection.Occurrence.QADialog.QAForm", [_WidgetBaseSP], {

        templateString: template,
        callback: function () { },
        occurrenceID: null,
        entityID: null,
        entity: null,
        jsonData: null,

        postMixInProperties: function(){
            this.inherited(arguments); // standard code aus basisklasse

        },
        postCreate: function () { // markup wurde eingelesen und im html-document angelegt
            this.inherited(arguments);

            //this.placeAt(document.body);
        },

        _loadData: function (entityID) {
            // request ...
        },

        serializeData: function () {
            var data = {
                occurrenceID: this.occurrenceID,
                question: this.inputQuestion.value,
                answer: this.inputAnswer.value
            };

            if (this.entity != null) {
                data.ID = this.entity.ID;
            }

            this.jsonData = data;
        },

        _getDataAttr: function () {
            return this.jsonData;
        },

        _setEntityAttr: function (entity) {
            this.entity = entity;
            this.onChanged_Entity();
        },

        onChanged_Entity: function () {
            var entity = this.entity;

            if (entity == null) {
                return;
            }

            this.occurrenceID = entity.ref_occurrence.ID;

            domAttr.set(this.authorNameNode, "innerHTML", entity.ref_asker.dispname);
            domAttr.set(this.responderNameNode, "innerHTML", entity.ref_responder.dispname);

            domAttr.set(this.inputQuestion, "value", entity.question);
            domAttr.set(this.inputAnswer, "value", entity.answer);

            this.applyPrivileges();
        },

        applyPrivileges: function () {
            var entity = this.entity;

            var bQuestionWriteable = false;
            var bAnswerWriteable = false;

            if (entity == null) { // neuer Datensatz
                bQuestionWriteable = true;
                bAnswerWriteable = false;
            } else {
                bQuestionWriteable = entity._isAsker == true;
                bAnswerWriteable = entity._isResponder == true;
            }

            if (bQuestionWriteable == true) {
                domAttr.remove(this.inputQuestion, "disabled");
                this.inputQuestion.focus();
            } else {
                domAttr.set(this.inputQuestion, "disabled", "disabled");
            }

            if (bAnswerWriteable == true) {
                domAttr.remove(this.inputAnswer, "disabled");
                this.inputAnswer.focus();
            } else {
                domAttr.set(this.inputAnswer, "disabled", "disabled");
            }
        },

        startup: function (entity) {  // ganz am ende nach instanzierung. zb zum größe berechnen oder abhängigkeiten anderer widgets prüfen
            this.inherited(arguments);

            if (typeof (entity) == "undefined" || entity == null) {
                this.applyPrivileges();
            }

            else if (typeof (entity) == "object") {
                // entity schon da
                this.set("Entity", entity);
            }

            else if (typeof (entity) == "string") { // ID
                this._loadData(entity);
            }
           
        },
        destroy: function () {
            this.inherited(arguments);
        },

    })
